import { IAdAdapter } from "./IAdAdapter";

export class RichAdsAdapter implements IAdAdapter {
  readonly name = "richads";

  constructor(private blockId: string) {}

  isAvailable(): boolean {
    const ctrl = (window as any).RichAdsCtrl;
    return !!ctrl && typeof ctrl.triggerInterstitialBanner === "function";
  }

  async requestAd(_type: "rewarded" | "interstitial"): Promise<boolean> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl) throw new Error("no RichAdsCtrl");
    if (!ctrl.triggerInterstitialBanner) throw new Error("no triggerInterstitialBanner");
    if ((window as any)._richAdsError) throw new Error("init error: " + (window as any)._richAdsError);
    return true;
  }

  async showAd(): Promise<boolean> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl?.triggerInterstitialBanner) throw new Error("SDK not ready");
    try {
      await Promise.race([
        ctrl.triggerInterstitialBanner(),
        new Promise<never>((_, rej) => setTimeout(() => rej(new Error("timeout")), 30000)),
      ]);
      return true;
    } catch (err) {
      throw new Error("richads show failed: " + ((err as any)?.message || err));
    }
  }

  async showAdInterstitial(): Promise<void> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl?.triggerInterstitialBanner) throw new Error("SDK not ready");
    try {
      await Promise.race([
        ctrl.triggerInterstitialBanner(),
        new Promise<never>((_, rej) => setTimeout(() => rej(new Error("timeout")), 30000)),
      ]);
    } catch (err) {
      throw new Error("richads inter failed: " + ((err as any)?.message || err));
    }
  }
}
